import type { VoidFunctionComponent } from 'react';
import DetailsPanelListRow from './DetailsPanelListRow';
import type { DetailsPanelListRowProps } from './DetailsPanelListRow';

type Props = {
  rows: DetailsPanelListRowProps[];
};

/**
 * DetailsPanelList renders a list of rows where
 * each
 * It can optionally be the "body" section of your DetailsPanel.
 *
 * @example
 * <DetailsPanel
 *   id="vuln-details"
 *   target="Details"
 *   isLoading={asyncStatus.isLoading}
 * >
 *   <DetailsPanelList
 *      rows={[
 *        {
 *          label: 'CWE',
 *          content: (<SomeBadge text="CWE-123" />)
 *        },
 *        {
 *          label: 'CVSS',
 *          content: (<SomeBadge text="CRITICAL" />)
 *        },
 *      ]}
 *   />
 * </DetailsPanel>
 */
const DetailsPanelList: VoidFunctionComponent<Props> = ({ rows }) => (
  //  Note: this is wrapped in a Fragment so that TS sees this as returning a single JSX.Element
  <>
    {rows.map(row => (
      <DetailsPanelListRow
        key={row.label}
        label={row.label}
        content={row.content}
      />
    ))}
  </>
);

export default DetailsPanelList;
